import { CommonStatusTag } from 'components/CommonStatusTag';

import { colors } from 'constants/colors';

import { MealPlanDefinitionState as MealPlanDefinitionStateEnum } from 'data/__generated__';

const getColorsFromState = (state: MealPlanDefinitionStateEnum) => {
    const { green, black, lightGrey } = colors;

    switch (state) {
        case MealPlanDefinitionStateEnum.Archived:
            return { backgroundColor: lightGrey, labelColor: black };
        case MealPlanDefinitionStateEnum.Regular:
            return { backgroundColor: green, labelColor: black };
    }
};

export const MEAL_PLAN_DEFINITION_STATE_LABELS: Record<MealPlanDefinitionStateEnum, string> = {
    [MealPlanDefinitionStateEnum.Archived]: 'Archivée',
    [MealPlanDefinitionStateEnum.Regular]: 'Active',
};

export const MealPlanDefinitionState = ({ state }: { state: MealPlanDefinitionStateEnum }) => {
    const { backgroundColor, labelColor } = getColorsFromState(state);

    return (
        <CommonStatusTag
            backgroundColor={backgroundColor}
            labelColor={labelColor}
            label={MEAL_PLAN_DEFINITION_STATE_LABELS[state]}
        />
    );
};
